import { useQuery } from 'react-query';
import axios from "axios";
import { checkRU, CACHE_TIME } from '../../index';
import ProceduresPreview from './ProceduresPreview';
import './ProceduresPreview.css';
import RouteUrl from '../RouteEnum';


const ProceduresList = () => {
    const { isRu, apiUrl } = checkRU();
    const queryPrefix = isRu ? "ru-" : "";
    const procedures = useQuery(queryPrefix + 'procedures',
        () => axios.get(apiUrl + RouteUrl.procedures).then(response => response.data), { cacheTime: CACHE_TIME });

    return (
        <div className="preview-list">
            {!procedures || !procedures.data || procedures.data.length <= 0 ? (<></>) :
                procedures.data.sort((a, b) => a.title_main.toUpperCase() > b.title_main.toUpperCase() ? 1 : -1).map(procedure => (<ProceduresPreview procedure={procedure} key={"procedure"+procedure.pk} />
                ))
            }
            </div>
    );
};

export default ProceduresList;